import * as Icons from '@ant-design/icons';
import {
  Alert,
  Button,
  Card,
  Divider,
  Form,
  Input,
  InputNumber,
  Typography
} from 'antd';
import { EditLayout } from 'components/layout/layout/EditLayout';
import { FileDoneOutlined } from '@ant-design/icons';
import {
  IAssignmentAttempt,
  IAssignmentAttemptCriterionFile,
  IAssignmentAttemptCriterionFileItem
} from 'interfaces/assignments';
import { PageHeader } from 'components/professor_area/PageHeader';
import { TagField, useForm } from '@refinedev/antd';
import { tagColorByStatus } from '../../../utils/statusColorMapping';
import { translateAssignmentAttemptStatus } from '../../../services/assignments';

export const AssignmentAttemptEdit = () => {
  const { formProps, saveButtonProps, queryResult } =
    useForm<IAssignmentAttempt>({
      redirect: 'list'
    });

  const attempt = queryResult?.data?.data;

  const disabled = ['failed', 'passed'].includes(attempt?.status ?? '');

  return (
    <EditLayout saveButtonProps={{ ...saveButtonProps, disabled }}>
      <PageHeader title="Corrigir tarefa" icon={FileDoneOutlined} />
      <Card>
        {disabled ? (
          <Alert
            style={{ marginBottom: 20 }}
            description={
              <>
                Essa tarefa já foi avaliada como{' '}
                <TagField
                  color={tagColorByStatus(attempt?.status ?? '')}
                  value={translateAssignmentAttemptStatus(
                    attempt?.status ?? ''
                  )}
                />
                e não pode ser modificada
              </>
            }
            type="warning"
          />
        ) : (
          <Alert
            style={{ marginBottom: 20 }}
            description={
              <>
                Você está avaliando a tarefa: <b>{attempt?.assignment_name}</b>
                <br />
                do curso/disciplina de: <b>{attempt?.course_name}</b>
              </>
            }
            type="info"
          />
        )}

        <Typography.Title level={5}>
          1. Faça o download dos arquivos necessários para a avaliar
        </Typography.Title>

        {attempt?.criteria_files.map(
          (criteria_file: IAssignmentAttemptCriterionFile) => (
            <>
              <Typography.Title level={5}>
                Critério: {criteria_file.name}
              </Typography.Title>

              {!criteria_file?.items?.length && (
                <Alert
                  type="warning"
                  showIcon
                  className="m-2 p-4"
                  message={
                    criteria_file.answer_type === 'file' ? (
                      <>
                        O aluno não enviou o arquivo <b>dentro do prazo</b>{' '}
                        estipulado para esta atividade
                      </>
                    ) : (
                      <>
                        O aluno não enviou sua resposta <b>dentro do prazo</b>{' '}
                        estipulado para esta atividade
                      </>
                    )
                  }
                />
              )}

              {criteria_file.items.map(
                (item: IAssignmentAttemptCriterionFileItem) => (
                  <>
                    <Button href={item.url} target="_blank" className="m-2">
                      <Icons.DownloadOutlined />
                      {item.name}
                    </Button>
                  </>
                )
              )}
            </>
          )
        )}
        <br />
        <Divider />

        <Typography.Title level={5}>
          2. Avalie o trabalho do aluno
        </Typography.Title>

        <Form disabled={disabled} {...formProps} layout="vertical">
          <Form.Item
            label="Nota (0 - 100)"
            name="score"
            rules={[
              {
                required: true
              }
            ]}
          >
            <InputNumber min={0} max={100} />
          </Form.Item>
          <Form.Item
            label="Feedback"
            name="feedback"
            rules={[
              {
                required: true
              }
            ]}
          >
            <Input.TextArea style={{ width: 500, height: 150 }} />
          </Form.Item>
        </Form>
      </Card>
    </EditLayout>
  );
};
